<div class="not-found-page">
  <div class="not-found-container">
    <div class="head">404</div>
    <div class="text">{{ "PAGE.PAGE_NOT_FOUND" | translate }}</div>
    <button class="btn btn-primary" (click)="home()">{{ "HOME" | translate }}</button>
  </div>
</div>
